import React, { lazy } from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy-loaded components
const NotificationTypeList = lazy(
  () =>
    import(
      "@/modules/eventNotifications/features/NotificationTypeManagement/components/NotificationTypeList/NotificationTypeList"
    ),
);

// Create stable component reference
const EventNotificationMainLayout = () => (
  <MainLayout section="event-notifications" />
);

const EventNotificationRoutes = (
  <Route
    element={
      <AuthenticationGuard component={EventNotificationMainLayout} />
    }
    path="/notifications"
  >
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_ADMIN", "ROLE_SUPER_ADMIN"]}>
          <NotificationTypeList />
        </PermissionGuard>
      }
      index
    />
  </Route>
);

export default EventNotificationRoutes;
